import { ErrorBoundary } from "components/ErrorBoundary";

import { Notifications } from "components/Notifications";
import { SidebarView } from "components/Sidebar";
import Alert from "components/SiteAlert";
import Header from "components/SiteHeader";
import UserMenu from "components/UserMenu";
import { ZenDesk } from "components/ZenDesk";
import { StudioConfig } from "models/Config";
import React, { FC } from "react";
import style from "./style.scss";
import { Button } from "@xapp/components";

export interface AppLayoutProps {
    config: StudioConfig;
    children?: JSX.Element[] | JSX.Element;
}

/**
 * Primary Layout for the Application
 *
 * It consists of a loading bar at the top, main navigation bar directly below it,
 * a notification system, help chat widget & primary content
 *
 * @param props
 */
export const AppLayout: FC<AppLayoutProps> = props => {

    const handleHelpClick = () => {
        const url = "/help/chat"
        window.open(url, "callout-option", "toolbar=0,status=0,width=600,height=700");
    }

    const { config } = props;
    return (
        <div>
            <div className={style.container}>

                <main className={style.container}>
                    <Header>
                        {/* Ad help button */}
                        <Button leftIcon="help_outline" label="Help" onClick={handleHelpClick} />
                        <UserMenu />
                    </Header>

                    <div className={style.content}>
                        <Alert />

                        <div className={style.subheader}>
                            <div id="secondary_nav_container">
                                {/*
                                        This container exists as a root for rendering secondary
                                        menus via the SecondaryNavView component
                                    */}
                            </div>
                        </div>

                        <ErrorBoundary>{props.children}</ErrorBoundary>
                    </div>

                    <SidebarView />
                </main>
            </div>
            <Notifications />
            {config.zendeskWidgetKey ? (<ZenDesk zendeskKey={config.zendeskWidgetKey} apiUrl={config.apiUrl} />) : (<></>)}
            <div id="modals_container" />
        </div>
    );
};
